<template>
  <div class="bc-status">
    <em
      v-if="tender.failed_bc_details"
      class="icon-exclamation status"
      :title="$t('tenders.bc_synced_status.error')"
    ></em>

    <em
      v-else
      class="icon-check"
      :title="$t('tenders.bc_synced_status.synced')"
    ></em>

  </div>
</template>

<script>
export default {
  name: "BCTenderStatus",

  props: {
    tender: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BCTenderStatus.vue